(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("VueMapTool", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["VueMapTool"] = factory(require("vue"));
	else
		root["VueMapTool"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_lRwf__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition